import React from "react";

/** Fondo global rojo Chili + franja decorativa inferior con imagen de marca. */
const CHILI_RED = "#DC2C27";
const CHILI_RED_RGB = "220, 44, 39";
const FOOTER_IMAGE = `${process.env.PUBLIC_URL || ""}/assets/img/footer/footer-chili.png`;
const FOOTER_HEIGHT = 75;

const FooterChili = () => {
  return (
    <>
      {/* Fondo rojo blur — capa trasera */}
      <div
        aria-hidden="true"
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 0,
          pointerEvents: "none",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: `
              radial-gradient(ellipse 85% 55% at 50% 58%, rgba(255, 255, 255, 0.72) 0%, transparent 68%),
              radial-gradient(ellipse 60% 50% at 32% 14%, rgba(${CHILI_RED_RGB}, 0.09) 0%, transparent 58%),
              radial-gradient(ellipse 100% 70% at 50% 100%, rgba(${CHILI_RED_RGB}, 0.1) 0%, transparent 52%),
              radial-gradient(ellipse 65% 55% at 0% 40%, rgba(${CHILI_RED_RGB}, 0.07) 0%, transparent 50%),
              radial-gradient(ellipse 65% 55% at 100% 20%, rgba(${CHILI_RED_RGB}, 0.06) 0%, transparent 50%),
              radial-gradient(ellipse 75% 55% at 55% 38%, rgba(${CHILI_RED_RGB}, 0.05) 0%, transparent 62%),
              linear-gradient(180deg, #ffffff 0%, #fffcfc 32%, #ffffff 52%, #fff9f9 72%, rgba(${CHILI_RED_RGB}, 0.05) 100%)
            `,
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "-15%",
            left: "10%",
            width: "55%",
            height: "45%",
            borderRadius: "50%",
            background: CHILI_RED,
            opacity: 0.08,
            filter: "blur(72px)",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "2%",
            left: "18%",
            width: "42%",
            height: "32%",
            borderRadius: "50%",
            background: CHILI_RED,
            opacity: 0.06,
            filter: "blur(80px)",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "5%",
            right: "-5%",
            width: "45%",
            height: "40%",
            borderRadius: "50%",
            background: CHILI_RED,
            opacity: 0.06,
            filter: "blur(88px)",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "40%",
            left: "20%",
            width: "60%",
            height: "38%",
            borderRadius: "50%",
            background: CHILI_RED,
            opacity: 0.04,
            filter: "blur(96px)",
          }}
        />
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(255, 255, 255, 0.38)",
          }}
        />
      </div>

      {/* Franja decorativa — estilo original */}
      <div
        aria-hidden="true"
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          height: FOOTER_HEIGHT,
          zIndex: 100,
          pointerEvents: "none",
          backgroundImage: `url(${FOOTER_IMAGE})`,
          backgroundRepeat: "repeat-x",
          borderRadius: "16px 16px 0 0",
        }}
      />
    </>
  );
};

export default FooterChili;
